// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"dbd00b87","688":"d21681c1"}[chunkId] + ".chunk.css";
};